"use client";

import { useRef, useState } from "react";
import { motion, useMotionValueEvent, useScroll } from "framer-motion";

export function ZoomInPartialOnScroll(props) {
  const [styles, setStyles] = useState({
    opacity: 0,
    translateY: 125,
    scale: 0.8,
  });
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start end", "end start"],
  });

  useMotionValueEvent(scrollYProgress, "change", (latest) => {
    let translateY = 125 - latest * 250;
    if (translateY < 0) translateY = 0;

    setStyles({
      opacity: latest * 4,
      translateY: translateY,
      scale: 0.8 + latest * 0.2,
    });
  });

  return (
    <motion.div {...props} style={styles} ref={ref}>
      {props.children}
    </motion.div>
  );
}
